module.exports = __webpack_public_path__ + "static/media/5.927b9ae3.jpg";